import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <RankingSection />
        <CarouselSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <IndexSection />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
        <AppSection />
        <UpdatesSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}